import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useDispatch } from 'react-redux';
import './styles.sass';

const useStyles = makeStyles({
    text: {
        '&&': {
            fontFamily: `'Rubik', sasn-serif`,
            lineHeight: 1.2
        }
    }
})

const RecipeCard = ({ recipe, setShowRecipe }) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const handlePickRecipe = () => {
        dispatch({ type: 'SET_PICKED_RECIPE', pickedRecipe: recipe });
        setShowRecipe(true);
    }

    return (
        <div className="card-container" onClick={handlePickRecipe}>
            <img src={recipe.image.url} alt={recipe.name} />
            <div className="details">
                <div className="category">
                    <Typography className={classes.text}>{recipe.category}</Typography>
                </div>
            </div>
            <Typography variant='h6' className={classes.text}>{recipe.name}</Typography>
        </div>
    )
}

export default RecipeCard;